import {
  ReviewAndSave,
  StepsDict,
  UserInformation
} from '@src/components/setup.steps'
import { StepTypes } from '@src/components/setup.steps/models/step.types'

import {
  AlertsConfiguration,
  AlertsConfigFooter
} from '../components/alerts.config'
import {
  UserInformationFooter,
  ReviewAndSaveFooter
} from '@src/components/setup.steps/components/footers'

import { Tabs } from '@src/components/common/circle.tabs'

interface RegisterSteps extends StepsDict, Tabs {}

const RegisterSteps: RegisterSteps = {
  1: {
    stepType: StepTypes.USER_INFORMATION,
    title: 'USER INFORMATION',
    className: 'userInformation',
    component: UserInformation,
    footerComponent: UserInformationFooter
  },
  2: {
    stepType: StepTypes.ALERT_SETTINGS,
    title: 'ALERT SETTINGS',
    className: 'alertSettings',
    component: AlertsConfiguration,
    footerComponent: AlertsConfigFooter
  },
  3: {
    stepType: StepTypes.REVIEW_INFORMATION,
    title: 'REVIEW INFORMATION',
    className: 'reviewAndSave',
    component: ReviewAndSave,
    footerComponent: ReviewAndSaveFooter
  }
}

export default RegisterSteps
